module.exports = __webpack_public_path__ + "img/57.44e15d5a.jpg";